/**
 * Product item quick-add / quick-view. Loaded as type="module".
 */

const cartAddPath = `${window.theme?.routes?.cart?.add || '/cart/add'}.js`

function addItemById(id, quantity) {
  return fetch(cartAddPath, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id, quantity }] }),
  })
    .then((r) => r.json())
    .then((res) => {
      if (res.status == '422') throw { code: 422, message: res.description }
      return { res }
    })
}

function cardTitle(button) {
  return (
    button.closest('.product-item')?.querySelector('.product-item__product-title, .product-item__title')?.textContent?.trim() ||
    button.getAttribute('aria-label') ||
    button.getAttribute('title') ||
    ''
  )
}

function trackQuickAdd(button) {
  if (!window.oneskin?.events) return

  let itemId = button.dataset.productId
  if (!itemId && button.dataset.productUrl) {
    try {
      itemId = new URL(button.dataset.productUrl, location.origin).searchParams.get('variant')
    } catch {
      itemId = undefined
    }
  }

  window.oneskin.events.track('quick_add_click', {
    product_name: cardTitle(button),
    item_id: itemId ? String(itemId) : undefined,
    source_location: 'plp',
  })
}

function onClick(event) {
  const button = event.target.closest('[data-quick-shop-trigger]')
  if (!button) return

  const type = button.dataset.quickShopTrigger

  if (type === 'quick-add') {
    event.preventDefault()
    event.stopPropagation()

    const { productId } = button.dataset
    if (!productId) return

    button.classList.add('loading')
    trackQuickAdd(button)
    window.oneskin?.events?.prepare('add_to_cart', {
      source_location: 'plp',
      product_name: cardTitle(button),
      item_id: String(productId),
    })

    addItemById(productId, 1)
      .then(() => {
        button.classList.remove('loading')
        window.NSHybridCart?.open()
      })
      .catch((error) => {
        button.classList.remove('loading')
        document.dispatchEvent(new CustomEvent('quick-add:error', { detail: { id: productId, error } }))
        console.error('[product-item] quick add failed', error)
      })
    return
  }

  if (type === 'quick-view') {
    event.preventDefault()
    event.stopPropagation()

    const { productUrl } = button.dataset
    if (!productUrl) return

    trackQuickAdd(button)
    document.dispatchEvent(new CustomEvent('quick-view:open', { detail: { productUrl } }))
  }
}

function init(root = document) {
  const scope = root.querySelectorAll ? root : document
  const containers = new Set()

  for (const item of scope.querySelectorAll('.product-item')) {
    containers.add(item.closest('[data-section-type]') || item.parentElement)
  }

  for (const container of containers) {
    if (!container) continue
    const items = [...container.querySelectorAll('.product-item')]
    items.forEach((item, i) => item.style.setProperty('--z-index-item', items.length - i))
  }
}

document.addEventListener('click', onClick)

init()

document.addEventListener('product-item:reinit', (event) => {
  init(event.detail?.root || document)
})

document.addEventListener('collection:updated', () => {
  init()
})

document.addEventListener('shopify:section:load', (event) => {
  init(event.target)
})

window.OneskinProductItem = init
